import React, { memo, useEffect } from 'react';

import { message, Skeleton } from 'antd';
// eslint-disable-next-line import/no-unresolved
import EasyVirtualizedScroller from 'easy-react-virtualized';
import { useNavigate } from 'react-router-dom';

import CommunityMessagesAPI from '../../../api/CommunityMessageAPI';
import Loader from '../../../components/Loader';
import {
  getNewUsers,
  newMessageUserInitiateState,
  updateNewMessageUserState,
} from '../../../context/communityMessageReducer';
import showAppError from '../../../shared/error';
import { useAppDispatch, useAppSelector } from '../../../shared/hooks';
import { IMessageRoomParticipant } from '../../../types/communityMessagesTypes';
import { ROUTES } from '../../../types/routes';
import CommunityUserCard from './CommunityUserCard';
import ListTitle from './ListTitle';

type Props = {
  searchQuery: string;
};

const CommunityMembers: React.FC<Props> = ({ searchQuery }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { newMessageUserState } = useAppSelector(
    (state) => state?.communityMessage,
  );
  const fetchUserList = async () => {
    if (newMessageUserState?.hasMore && !newMessageUserState?.loading) {
      dispatch(
        getNewUsers(
          {
            page: newMessageUserState?.page,
            users: newMessageUserState?.users,
          },
          searchQuery,
        ),
      );
    }
  };

  const handleCraeteDM = async (userId: string) => {
    try {
      // Logic to create DM
      const resp = await CommunityMessagesAPI.createNewDMRoomforUser(userId);
      if (resp.status === 201) {
        message.success('DM created successfully');
        navigate(
          ROUTES.COMMUNITY_MESSAGES_ROOM.replace(
            ':roomId',
            resp?.data?.result?._id,
          ),
        );
      } else {
        // Handle error
        showAppError(resp?.data);
        console.error('Error creating DM:', resp);
      }
    } catch (error) {
      showAppError(error);
      console.error('Error creating DM:', error);
    }
  };

  const displayUserCardList = (list: IMessageRoomParticipant[]) => {
    return (
      <>
        {list.map((eachData) => (
          <CommunityUserCard
            user={{
              _id: eachData?._id,
              name: eachData?.name,
              profilePicUrl: eachData?.profilePicUrl,
              profilePicType: 'image',
            }}
            isClickable
            onClick={() => {
              handleCraeteDM(eachData?._id);
            }}
          />
        ))}
      </>
    );
  };

  useEffect(() => {
    dispatch(updateNewMessageUserState(newMessageUserInitiateState));
  }, [dispatch, searchQuery]);

  return (
    <div>
      <EasyVirtualizedScroller
        useParentScrollElement
        key={'new-message-users'}
        hasMore={newMessageUserState.hasMore}
        onLoadMore={fetchUserList}>
        <div key={'this-is-user-list'}>
          <ListTitle title={'Members'} key={'this-is-member-list'} />
          <>{displayUserCardList(newMessageUserState?.users)}</>
          {newMessageUserState.loading ? (
            <Loader
              style={{
                width: '100%',
                textAlign: 'center',
                marginTop: 16,
              }}
            />
          ) : null}
        </div>
      </EasyVirtualizedScroller>
      {newMessageUserState.loading || newMessageUserState?.hasMore ? (
        <>
          {Array(10)
            .fill(1)
            .map(() => (
              <Skeleton avatar paragraph={{ rows: 1 }} />
            ))}
        </>
      ) : null}
      {!newMessageUserState.loading &&
      !newMessageUserState?.hasMore &&
      newMessageUserState?.users?.length === 0 ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}>
          <span style={{ fontSize: 16, color: '#888' }}>No members found</span>{' '}
        </div>
      ) : null}
    </div>
  );
};

export default memo(CommunityMembers);
